/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
var ChevronDownIcon = function ChevronDownIcon(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
  }));
};

ChevronDownIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};
import React from 'react';

function AccordionItem(_ref) {
  var active = _ref.active,
      children = _ref.children,
      onToggle = _ref.onToggle,
      title = _ref.title;
  return React.createElement("li", {
    className: "accordion-item ".concat(active ? 'active' : '')
  }, React.createElement("div", {
    className: "accordion-title",
    onClick: onToggle
  }, React.createElement("h5", null, title), React.createElement(ChevronDownIcon, null)), active && React.createElement("div", {
    className: "accordion-body"
  }, React.createElement("div", {
    className: "accordion-content"
  }, children)));
}

export default AccordionItem;